// extracted by mini-css-extract-plugin
export default {"link":"gD-z","disabled":"hD-z"};